import { actionCreator } from 'app-webtech-core/actions/actionCreator';
import { CHANNEL_ERROR } from './types';

const thunkAction = actionCreator(CHANNEL_ERROR);

export const channelErrorThunkAction = (error) => (dispatch) => dispatch(thunkAction({ error }));
